webpackJsonp([35783957827783],{

/***/ 103:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Albums = function Albums(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'article',
	    { className: 'cf' },
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/BEYONC\xC9-Beyonce/dp/B00KCOMBJC/ref=sr_1_2_twi_lp__3?s=music&ie=UTF8&qid=1480422067&sr=1-2&keywords=beyonce&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Beyonc\xE9', style: { backgroundImage: 'url(https://classicalbumcovers.files.wordpress.com/2013/03/fragileyes.jpg?w=800)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/99-9-KAYTRANADA/dp/B01D9DBNX2/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480422105&sr=1-1&keywords=kaytranada+vinyl&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Kaytranada', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/kaytranada.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Woman-2LP-Set-Full-Album/dp/B01LX3E0ET/ref=sr_1_1?s=music&ie=UTF8&qid=1480422119&sr=1-1&keywords=justice&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Woman - Justice', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/justice.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Skin-Flume/dp/B01DD5N35W/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480422133&sr=1-1&keywords=flume&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Skin - Flume', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/flume.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Seat-at-Table-Solange/dp/B01LXP7I5N/ref=sr_tnr_p_1_195429011_1_twi_lp__3?s=music&ie=UTF8&qid=1480422087&sr=1-1&keywords=solange+seat+at+the+table&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Seat at Table Solange', style: { backgroundImage: 'url(https://f4.bcbits.com/img/a0732680783_10.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/untitled-unmastered-LP-Kendrick-Lamar/dp/B01DET9BV2/ref=sr_1_3_twi_lp__3?s=music&ie=UTF8&qid=1480370912&sr=1-3&keywords=kendrick+lamar&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Untitled Unmastered - Kendrick Lamar', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/untitledunmastered.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-100 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Moon-Shaped-Pool-2-LP-Download/dp/B01FDF12UI/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480370971&sr=1-1&keywords=moon+shaped+pool&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Moon Shaped Pool 2', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/moonshapedpool.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Colour-Anything-2-LP/dp/B01F8674B8/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480371036&sr=1-1&keywords=color+in+anything&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Colour Anything 2', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/colouranything.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-50 w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Good-Luck-Do-Your-Best/dp/B01C3IHINI/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480371123&sr=1-1&keywords=good+luck+gold+panda&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Good Luck Do Your Best', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/goldpanda.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-100 w-50-m w-25-ns' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/32-Levels-Clams-Casino/dp/B01GU83I4K/ref=sr_1_2_twi_lp__1?s=music&ie=UTF8&qid=1480371183&sr=1-2&keywords=clams+casino&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': '32 Levels Clams Casino', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/clamscasino.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Danny-Brown-Atrocity-Exhibition-Exclusive/dp/B01M9F0LSQ/ref=sr_1_2?ie=UTF8&qid=1480421198&sr=8-2&keywords=danny+brown+vinyl&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Danny Brown Atrocity Exhibition Exclusive', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/dannybrown.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-100 w-50-m w-25-l' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fl w-100' },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.amazon.com/Human-Energy-MACHINEDRUM/dp/B01HC7UTBI/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480371226&sr=1-1&keywords=human+energy&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	          _react2.default.createElement('span', { role: 'img', 'aria-label': 'Human Energy - Machinedrum', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/humanenergy.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'fl w-100' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-50' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.amazon.com/Moodymann-DJ-Kicks-DJ-KICKS/dp/B01AEOM6D0/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480371894&sr=1-1&keywords=dj+kicks+moodymann&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	            _react2.default.createElement('span', { role: 'img', 'aria-label': 'Moodymann - DJ Kicks', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/moodyman.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-50' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.amazon.com/Stranger-Things-Netflix-Original-Soundtrack/dp/B01KA4MVF2/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480423240&sr=1-1&keywords=stranger+things&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	            _react2.default.createElement('span', { role: 'img', 'aria-label': 'Stranger Things Netflix Original Soundtrack', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/strangerthings.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-50' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.amazon.com/How-Be-Human-Being-LP/dp/B01GQ7DIJA/ref=tmm_vnl_swatch_0?_encoding=UTF8&qid=1480421224&sr=8-1&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	            _react2.default.createElement('span', { role: 'img', 'aria-label': 'How Be Human Being LP', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/glassanimals.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-50' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.amazon.com/22-Million-Bon-Iver/dp/B01KBKVK2K/ref=sr_tnr_p_6_195212011_1_twi_lp__3?s=music&ie=UTF8&qid=1480422776&sr=1-6&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	            _react2.default.createElement('span', { role: 'img', 'aria-label': '22 Million - Bon Iver', style: { backgroundImage: 'url(http://mrmrs.github.io/photos/boniver.jpg)' }, className: 'bg-center cover aspect-ratio--object' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fl w-100 w-50-l' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.amazon.com/Malibu-Anderson-Paak/dp/B01BXNXBAS/ref=sr_1_1_twi_lp__3?s=music&ie=UTF8&qid=1480422041&sr=1-1&keywords=paak&tag=mrmrs01-20', className: 'db aspect-ratio aspect-ratio--1x1 dim' },
	        _react2.default.createElement('span', { role: 'img', 'aria-label': 'Malibu -  Anderson Paak', className: 'bg-center cover aspect-ratio--object',
	          style: {
	            backgroundImage: 'url(http://mrmrs.github.io/photos/paak.jpg)'
	          }
	        })
	      )
	    )
	  );
	};
	
	exports.default = Albums;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _albums = __webpack_require__(199);
	
	var _albums2 = _interopRequireDefault(_albums);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_albums2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ffab8c3e2f59f082bd4e.js